<template>
  <div class="">
    <div class="head-title">客户级别管理</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>1、企业客户的等级划分可根据行业实际进行自定义设置添加。</p>
          <p>
            2、企业设置等级划分时需要设定跟进天数，当员工在规定时间内未及时跟进，线索将自动掉入公海。例如：假设A级客户跟进添加为3天，未成交天数为30天，员工在3天内未跟进或30天未成交将会自动掉入公海。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-button
            icon="el-icon-plus"
            @click="(onSubmit = true), tianjia()"
            type="primary"
            >添加
          </el-button>
        </div>
        <div class="nav-r">
          <el-input
            clearable
            placeholder="请输入名称搜索"
            style="width: 35.0rem; "
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          >
          <el-button slot="append" @click="rune()" type="primary"
            >查询</el-button
          >
          </el-input>

        </div>
      </nav>
      <el-table
        :data="tableData"
        border
        v-loading="tableLoading"
        style="width: 100%; margin-top: 2.0rem"

        v-infinite-scroll="load"
      >
      <!---height="560"-->
        <el-table-column
          prop="name"
          label="名称"
          style="width: 10%"
        ></el-table-column>
        <el-table-column
          prop="customer_follow_days"
          label="客户跟进天数"
          style="width: 10%"
        ></el-table-column>
        <el-table-column
          prop="customer_deal_days"
          label="客户未成交天数"
          style="width: 10%"
        ></el-table-column>
        <el-table-column
          prop="createtime"
          label="添加时间"
          style="width: 50%"
        ></el-table-column>
        <el-table-column
          prop="updatetime"
          label="修改时间"
          style="width: 50%"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="300">
          <template slot-scope="scope">
            <div v-if="scope.row.phone != '系统管理员'">
              <el-button
                @click="
                  (onSubmitn = true),
                    bianji(
                      scope.row.id,
                      scope.row.name,
                      scope.row.customer_follow_days,
                      scope.row.customer_deal_days
                    )
                "
                size="mini"
                type="text"
                >编辑</el-button
              >
              <el-button
                size="mini"
                @click="handleClick(scope.row.id)"
                type="text"
                style="color:#f00000 !important;"
              >
                删除
              </el-button>
            </div>
            <div v-else-if="scope.row.phone == '系统管理员'">
              <el-button type="primary" disabled>编辑</el-button>
              <el-button type="danger" disabled> 移除 </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div>
            <pagination
              :total="total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              :auto-scroll="false"
              @pagination="userTable"
            />
          </div>
      <el-dialog title="添加客户级别" center :visible.sync="onSubmit" width="30%">
        <!-- <div class="bule"></div> -->
        <el-form ref="form" :model="form" :rules="rules" label-width="15.0rem">
          <el-form-item label="名称" prop="name" >
            <el-input clearable v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="客户跟进天数" prop="customer_follow_days">
            <el-input clearable
            type="number"
            @blur="getValueData"
            min="0"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
            v-model="form.customer_follow_days">
            </el-input>
          </el-form-item>
          <el-form-item label="客户未成交天数" prop="customer_deal_days">
            <el-input
            clearable
            type="number"
            min="0"
            v-model="form.customer_deal_days"
            @blur="getValueData"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSubmit = false">取 消</el-button>
          <el-button type="primary" @click="numoo()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="编辑" center :visible.sync="onSubmitn" width="30%">
        <!-- <div class="bule"></div> -->

        <el-form ref="form" :model="form" :rules="rules" label-width="15.0rem">
          <el-form-item label="名称" prop="none" >
            <el-input clearable v-model="bianjile">{{ bianjile }}</el-input>
          </el-form-item>
          <el-form-item label="客户跟进天数" prop="customer_follow_days">
            <el-input
            type="number"
            @blur="getValueData"
            min="0"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
            clearable
            v-model="customer_follow_days"
            >{{
              customer_follow_days
            }}</el-input>
          </el-form-item>
          <el-form-item label="客户未成交天数" prop="customer_deal_days">
            <el-input
            clearable
            type="number"
            min="0"
            @blur="getValueData"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
            v-model="customer_deal_days"
            >{{
              customer_deal_days
            }}</el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSubmitn = false">取 消</el-button>
          <el-button type="primary" @click="numoon()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "monitoring",
  data() {
    return {
      title: {},
      tooken: "",
      tableData: [],
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
        customer_deal_days: "",
        customer_follow_days: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      customer_deal_days: "",
      customer_follow_days: "",
      lock: true,
      code: "",
      numDay:0,
      rules:{
        name: [
            { required: true, message:'名称不能为空', trigger: 'blur' }
          ],
        none: [
          { required: true, message:'名称不能为空', trigger: 'blur' }
        ],
        },
      total: 0,
      listQuery: {
      page: 1,
        limit: 20,
        tableLoading: true,
      },
    }
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    //  页数
    load() {
      this.yeshu += 1;

      if (this.code == 1) {
        this.axios
          .post(
            "/crm/CustomerLevel/getCustomerLevel",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              page: this.yeshu,
              name: this.input2,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.code = res.data.code;
            if (res.data.code == 1) {
              this.lock = true;
            } else if (res.data.code == 0) {
              this.lock = false;
            }
            res.data.data.forEach((item) => {
              this.tableData.push(item);
            });
          })
          .catch(function (err) {});
      } else {
        return;
      }
    },
    userTable() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/getCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.tableData = res.data.data;
          this.total=res.data.count;
        })
        .catch(function (err) {});
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/getCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o, l, p) {
      this.yeshu = 1;
      this.ele = e;
      this.bianjile = o;
      this.form.none = o
      this.customer_follow_days = l;
      this.customer_deal_days = p;


    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/editCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.bianjile,
            id: this.ele,
            customer_follow_days: this.customer_follow_days,
            customer_deal_days: this.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/addCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.name,
            customer_follow_days: this.form.customer_follow_days,
            customer_deal_days: this.form.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.form.name="";
            this.form.customer_deal_days="";
            this.form.customer_follow_days=""
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerLevel/delCustomerLevel",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },

    /*限制天数只能为数字类型*/
    getValueData() {
      if (this.numDay) {
        let a = this.numDay.substring(0, 1);
        let b = this.numDay.substring(1, 2);
        if (a == '0' && b != '.') {
          this.numDay = this.numDay.slice(1);
        }
      }
  }
}

};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
}
.shij:nth-child(1) {
  margin-right: 2.4rem;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.el-button--text{padding-left:.0rem !important;}
</style>
